// extracted by mini-css-extract-plugin
export default {"root":"GVwXl4EtjMe14cU8H57Q","page":"kCpePbflnju0aLSWuzWP"};